import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Constants, Globals } from 'utils';
import { clearAllDraftsOnLogout } from 'utils/vehicleDraftDB';
import Header from './header';
import $ from 'jquery';
import { ArrowUp, ArrowBottom, Menu as MenuIcons, LogoutIcon } from 'assets/icons';

export interface MenuItem {
	name: string;
	path: string;
	submenu?: MenuItem[];
	icon?: string;
	permission?: string;
	onClick?: () => void;
	iconActive?: string;
	code?: string;
	isLogout?: boolean;
}

class Menu extends React.Component<any> {

	state: any = {
		leftOpen: this.props.sidebar,
		openResponsive: false,
		items: [
			{ name: 'Mi Perfil', path: '/profile', icon: MenuIcons.Menu1, iconActive: MenuIcons.Menu1 },
			{ name: 'Administrar Vehículos', path: '/client/vehicles', icon: MenuIcons.Menu2, iconActive: MenuIcons.Menu2 },
			{ name: 'Conductores', path: '/client/drivers', icon: MenuIcons.Menu3, iconActive: MenuIcons.Menu3 },
			{ name: 'Administradores', path: '/client/moderators', icon: MenuIcons.Menu4, iconActive: MenuIcons.Menu4 },
			{ name: 'Ayudantes', path: '/client/assistants', icon: MenuIcons.Menu5, iconActive: MenuIcons.Menu5 },
		],
		items_client_moderator: [
			{ name: 'Mi Perfil', path: '/profile', icon: MenuIcons.Menu1, iconActive: MenuIcons.Menu1 },
			{ name: 'Administrar Vehículos', path: '/moderators/vehicles', icon: MenuIcons.Menu2, iconActive: MenuIcons.Menu2 },
			{ name: 'Conductores', path: '/moderators/drivers', icon: MenuIcons.Menu3, iconActive: MenuIcons.Menu3 },
			{ name: 'Ayudantes', path: '/moderators/assistants', icon: MenuIcons.Menu5, iconActive: MenuIcons.Menu5 },
		],
		items_drivers: [
			{ name: 'Mi Perfil', path: '/profile', icon: MenuIcons.Menu1, iconActive: MenuIcons.Menu1 },
		]
	}

	toggleSidebar = () => {
		let key: any = `leftOpen`;
		// @ts-ignore
		this.setState({ [key]: !this.state[key] }, () => {
			this.props.dispatch({
				type: 'SET_SIDEBAR',
				payload: this.state.leftOpen
			});
		});
	}

	checkActive = (value: string, current: string) => {
		return current.includes(value);
	}

	changeMenu = (item: MenuItem) => {
		if (item.submenu && !this.state.leftOpen) {
			this.toggleSidebar();
		}
	}

	checkPermission = (item: any) => {
		if (this.props.user?.level_id === Constants.LEVELS.ADMIN) {
			return true;
		}
		const permissions = this.props.user?.module_permissions?.filter((i: any) => i.read).map((i: any) => i.module_id) || [];
		if (Array.isArray(item.permission)) {
			let _continue = false;
			item.permission.forEach((i: any) => {
				if (permissions.indexOf(i) !== -1) {
					_continue = true;
				}
			});
			return _continue;
		}
		else {
			return permissions.indexOf(item.permission) !== -1;
		}
	}

	closeNavbar = () => {
		// @ts-ignore
		$('#collapsibleNavbar').collapse('hide');
	}

	toggleResponsive = () => {
		this.setState({
			openResponsive: !this.state.openResponsive
		});
	}

	closeResponsive = () => {
		this.setState({
			openResponsive: !this.state.openResponsive
		});
	}

	onMenuItemClick = (e: any, i: MenuItem) => {
		if (i.onClick) {
			e.preventDefault();
			i.onClick();

		} else {
			if (i.submenu && i.submenu.length > 0 && this.checkActive(i.path, this.props.history.location.pathname) && this.props.open_menu) {
				this.props.dispatch({
					type: 'SET_OPEN_MENU',
					payload: false
				});
				e.preventDefault();
			}
			else {
				this.props.dispatch({
					type: 'SET_OPEN_MENU',
					payload: true
				});
				this.changeMenu(i);
				this.closeResponsive();
			}
		}
	}

	logout = () => {
		Globals.confirm('¿Desea cerrar sesión?', async () => {
			// NOTA: NO limpiamos drafts al cerrar sesión para que el usuario
			// pueda continuar su registro cuando vuelva a iniciar sesión
			// Si necesitas limpiar drafts, descomenta las siguientes líneas:
			// const userId = this.props.user?.id;
			// if (userId) {
			//   await clearAllDraftsOnLogout(userId);
			// }
			
			this.props.dispatch({ type: 'SET_USER', payload: null });
			this.props.dispatch({ type: 'SET_ACCESS_TOKEN', payload: null });
			this.props.history.replace('/login');
			Globals.quitLoading();
		});
	}

	render() {
		let leftOpen = !this.props.isAuth && this.state.leftOpen ? "open" : "closed";
		let items = [];

		if (this.props.user) {
			switch (this.props.user?.level_id) {
				case Constants.LEVELS.ADMIN:
					items = this.state.items;
					break;

				case Constants.LEVELS.CLIENT:
					items = this.state.items;
					break;

				case Constants.LEVELS.DRIVER:
					items = this.state.items_drivers;
					break;

				case Constants.LEVELS.CLIENT_MODERATOR:
					items = this.state.items_client_moderator;
					break;
			}
		}

		return (
			<React.Fragment>
				{/*{
					items.length > 0 && (
						<nav className="navbar navbar-expand-lg bg-dark navbar-dark fixed-top justify-content-start">
						  <button className="navbar-toggler" type="button" onClick={ this.toggleResponsive }>
						    <img src={ MenuIcon } />
						  </button>
					    </nav>
					)
				}*/}

				<div id="left" className={leftOpen}>
					<div className={`sidebar ${leftOpen + ' ' + (this.state.openResponsive ? 'open-responsive' : '')}`}>
						<div className={`shadow-close ${this.state.openResponsive ? 'open' : ''}`} onClick={this.closeResponsive}></div>
						<div className="container-menu">
							<div className={`menu ${leftOpen}`}>
								<div className="container-scroll">
									{/*<button className={ `navbar-toggler navbar-toggler-menu ${ leftOpen }` } type="button" onClick={ () => {
										this.toggleSidebar();
									} }>
										<img src={ MenuIcon } />
									</button>
									<button className={ `navbar-toggler navbar-toggler-menu responsive ${ leftOpen }` } type="button" onClick={ () => {
										this.toggleResponsive();
									} }>
										<img src={ MenuIcon } />
									</button>*/}
									<ul className={leftOpen}>
										{items.map((i: MenuItem, index: number) => {
											return (
												<React.Fragment key={index}>
													{
														(!i.permission || this.checkPermission(i)) && (
															<li className={`nav-item ${this.checkActive(i.path, this.props.history.location.pathname) ? 'active' : ''}`}>
																<Link
																	to={i.path}
																	className={`${i.submenu && i.submenu.length > 0 ? 'contain-submenu' : ''}`}
																	onClick={e => this.onMenuItemClick(e, i)}
																>
																	<div className={`container-icon-menu ${leftOpen} ${this.checkActive(i.path, this.props.history.location.pathname) ? 'active' : ''}`}>
																		{
																			i.icon && (
																				<img src={this.checkActive(i.path, this.props.history.location.pathname) ? i.iconActive : i.icon} alt="" />
																			)
																		}
																	</div>
																	<span className={leftOpen}>
																		{i.name}
																		{
																			i.submenu && i.submenu.length > 0 && (
																				<React.Fragment>
																					{
																						this.checkActive(i.path, this.props.history.location.pathname) ? (
																							<img className="arrow-drop" src={this.props.open_menu ? ArrowUp : ArrowBottom} alt="" />
																						) : (
																							<img className="arrow-drop" src={ArrowBottom} alt="" />
																						)
																					}
																				</React.Fragment>
																			)
																		}
																	</span>
																</Link>
																{
																	this.props.open_menu && (
																		<div className={`${i.submenu && i.submenu.length > 0 && this.checkActive(i.path, this.props.history.location.pathname) ? 'container-submenu' : ''}`}>
																			{
																				leftOpen !== 'closed' && this.checkActive(i.path, this.props.history.location.pathname) && i.submenu && i.submenu.map((item: MenuItem, index: number) => {
																					if (!item.permission || this.checkPermission(item)) {
																						return (
																							<li className={'nav-item item-submenu ' + (this.props.history.location.pathname === item.path ? 'active' : '')}>
																								<Link to={item.path} className="submenu">
																									{
																										item.icon && (
																											<img src={item.icon} alt="" />
																										)
																									}
																									{item.name}
																								</Link>
																							</li>
																						)
																					}
																				})
																			}
																		</div>
																	)
																}
															</li>
														)
													}
												</React.Fragment>
											)
										})}
									</ul>

									<ul className={leftOpen}>
										<li className="nav-item" onClick={this.logout}>
											<Link to="#">
												<div className={`container-icon-menu ${leftOpen}`}>
													<img src={LogoutIcon} alt="Salir" />
												</div>
												<span className={leftOpen}>Salir</span>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div className={`container-router ${leftOpen}`}>
							<Header className={leftOpen + ' ' + (items.length > 0 && 'header-responsive')} toggleSidebar={() => this.toggleSidebar()} toggleResponsive={() => this.toggleResponsive()} />
							<div className={`container-padding-router ${items.length > 0 && 'container-responsive'}`}>{this.props.children}</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

export default connect((state: any) => {
	return {
		user: state.user,
		open_menu: state.open_menu,
		sidebar: state.sidebar
	}
})(Menu);